/* istanbul ignore file */
import { PostHogProvider } from "posthog-js/react";
import { BrowserRouter } from "react-router-dom";
import {
  ApiConfigProvider,
  AuthorizationProvider,
  ErrorBoundary,
} from "@consumerig/iv-components";
import {
  REACT_APP_POSTHOG_ENABLED,
  REACT_APP_PUBLIC_POSTHOG_HOST,
  REACT_APP_PUBLIC_POSTHOG_KEY,
} from "./helpers/constants";
import PostHogIdentityProvider from "./common/PostHogIdentityProvider";
import posthog from "posthog-js";
import { getLoginToken } from "./helpers/helperMethods";
import { AppRoutes } from "./routes";

if (REACT_APP_POSTHOG_ENABLED === "true") {
  posthog.init(REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
    person_profiles: "identified_only",
    autocapture: false,
  });
}

function App() {
  return (
    <PostHogProvider client={posthog}>
      <ErrorBoundary posthog={posthog}>
        <ApiConfigProvider
          apiURL={process.env.REACT_APP_API_URL}
          token={getLoginToken()}
          domain={process.env.REACT_APP_TOKEN_COOKIE_DOMAIN}
          loginURL={process.env.REACT_APP_LOGIN_URL || "/auth"}
        >
          <AuthorizationProvider>
            <PostHogIdentityProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </PostHogIdentityProvider>
          </AuthorizationProvider>
        </ApiConfigProvider>
      </ErrorBoundary>
    </PostHogProvider>
  );
}

export default App;
